import { Badge, type AreaNavListItem } from "@octopusdeploy/design-system-components";
import { links } from "@octopusdeploy/portal-routes";
import { useIsTrial } from "~/areas/configuration/components/LicenseUsage/useIsTrial";
import { usePlatformHubOctopusFeatureToggles, type PlatformHubOctopusFeatureToggles } from "~/hooks/useOctopusFeatureToggle";
import { useIsLicensedFeatureEnabled } from "../LicensedFeature/useIsLicensedFeatureEnabled";
import { type AreaNavPanelConfig } from "./AreaNavPanelConfig";
export function usePlatformHubAreaNavPanel(): AreaNavPanelConfig | undefined {
    const isProcessTemplatesLicensed = useIsLicensedFeatureEnabled("ProcessTemplates");
    const isCompliancePoliciesLicensed = useIsLicensedFeatureEnabled("Policies");
    const isPlatformHubLicensed = isProcessTemplatesLicensed || isCompliancePoliciesLicensed;
    const platformHubFeature = usePlatformHubOctopusFeatureToggles();
    const isTrial = useIsTrial();
    const areaNavPanelItems = usePlatformHubNavPanelItems(platformHubFeature);
    if (!isPlatformHubLicensed) {
        return undefined;
    }
    return {
        items: areaNavPanelItems,
        title: "Platform Hub",
        badge: isTrial ? <Badge size="medium" variant="upsell" label="Enterprise" hideIcon={true}/> : undefined,
    };
}
function usePlatformHubNavPanelItems(features: PlatformHubOctopusFeatureToggles): ReadonlyArray<AreaNavListItem> {
    return [
        {
            heading: undefined,
            items: [
                { label: "Project Templates", href: links.projectTemplatesPage.generateUrl(), isVisible: features.projectTemplates },
                { label: "Process Templates", href: links.processTemplatesPage.generateUrl() },
                { label: "Policies", href: links.policiesPage.generateUrl() },
            ],
            hasTrailingDivider: true,
        },
        { heading: "Compliance", items: [{ label: "Reports", href: links.complianceReportsPage.generateUrl(), isVisible: features.complianceReports }], hasTrailingDivider: true },
        {
            heading: "Infrastructure",
            items: [
            //{ placeholderLabel: "Environments" },
            //{ placeholderLabel: "Workers" },
            //{ placeholderLabel: "Worker Pools" },
            ],
            hasTrailingDivider: true,
        },
        {
            heading: "Manage",
            items: [
                { label: "Accounts", href: links.platformHubAccountsPage.generateUrl() },
                //{ placeholderLabel: "Certificates" },
                //{ placeholderLabel: "External Feeds" },
                { label: "Git Credentials", href: links.platformHubGitCredentialsPage.generateUrl() },
                { label: "GitHub Connections", href: links.platformHubGitHubConnectionsPage.generateUrl(), isVisible: features.platformHubGitHubConnections },
                //{ placeholderLabel: "Lifecycles" },
            ],
            hasTrailingDivider: true,
        },
        {
            heading: "Configuration",
            items: [{ label: "Settings", href: links.platformHubVersionControlSettingsPage.generateUrl() }],
        },
    ];
}
